import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "table table-bordered mt-4 mb-4" }
const _hoisted_6 = {
  key: 0,
  style: {"width":"180px"}
}
const _hoisted_7 = ["rowspan"]
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-end",
  style: {"width":"180px"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              type: "h5",
              localizedKey: "Providers",
              text: "Providers"
            })
          ]),
          _hoisted_4,
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Layer",
                    text: "Layer"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Production Phase",
                    text: "Production Phase"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Provider",
                    text: "Provider"
                  })
                ]),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providersInvolved, (phases, category) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phases, (phase, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            rowspan: phases.length
                          }, _toDisplayString(category), 9, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, _toDisplayString(phase.productionPhase) + " - " + _toDisplayString(phase.productionPhaseCountry), 1),
                      _createElementVNode("td", null, _toDisplayString(phase.provider.text ? phase.provider.text : '--'), 1),
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                            _createElementVNode("button", {
                              class: "btn btn-tertiary",
                              onClick: ($event: any) => (_ctx.editProviderPerPhase(phase, category))
                            }, [
                              (!phase.provider.text)
                                ? (_openBlock(), _createBlock(_component_localized_text, {
                                    key: 0,
                                    localizedKey: "Choose a provider",
                                    text: "Choose a provider"
                                  }))
                                : (_openBlock(), _createBlock(_component_localized_text, {
                                    key: 1,
                                    localizedKey: "Change provider",
                                    text: "Change provider"
                                  }))
                            ], 8, _hoisted_9)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 64))
              }), 128))
            ])
          ]),
          _createVNode(_component_localized_text, {
            localizedKey: "N.B. If the chosen suppliers have their own values for water footprint and land impact, the values seen above will be overwritten",
            text: "N.B. If the chosen suppliers have their own values for water footprint and land impact, the values seen above will be overwritten",
            class: "d-block mb-5 fw_700"
          })
        ]),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-secondary me-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Previous",
                  text: "Previous"
                })
              ]),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}